// removed by extract-text-webpack-plugin
module.exports = {"column-total":"Charts_table-item_column-total---2bzAE","draggable-columns":"Charts_table-item_draggable-columns---2bc1D"};